const HomeParagraph = () => {
  return (
    <section className="bg-gray-100 flex items-center justify-center py-2 px-4 text-sm text-gray-700">
      <p className="text-center max-w-xl">
        Grey Techs delivers expert surveillance camera installation, structured cabling, VoIP systems, 
        and on-site IT support for small businesses across Central and Southern Ohio. Trusted by 
        providers like Mendtronix, M7 Services, and Integrated Health Systems for reliable technical solutions.
      </p>
    </section>
  );
};

export default HomeParagraph;